module.exports = __webpack_public_path__ + "img/icon-printer.0b0d39a8.svg";